.toolbar {
  padding: 6px;
  display: flex;
  justify-content: space-between;
}

.dropdown,
.label {
  display: flex;
  align-items: center;
}

.label {
  margin-right: 6px;
  line-height: 1;
  font-weight: 400;
  font-size: 14px;
  color: white;
}

.icon {
  margin-right: 7px;
}

.select {
  padding: 6px 5px;
  font-size: 12px;
  border: 1px solid #959595;
  border-radius: 3px;
  min-width: 90px;
  line-height: 1;
}
